import { JOURNEY } from "@/content/site";
import { Reveal } from "./primitives";

/** Five-step proposed patient journey. variant "dark" for plum sections. */
export const JourneySteps = ({ variant = "dark" }) => {
  const dark = variant === "dark";
  return (
    <ol data-testid="journey-steps" className="relative grid gap-10 lg:grid-cols-5 lg:gap-6">
      <span aria-hidden="true" className={`absolute left-[23px] top-3 h-[calc(100%-24px)] w-px lg:left-0 lg:top-[23px] lg:h-px lg:w-full ${dark ? "bg-white/15" : "bg-plum/15"}`} />
      {JOURNEY.map((s, i) => (
        <Reveal as="li" key={s.title} delay={i * 0.08} className="relative flex gap-5 lg:block">
          <span className={`relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full font-display text-lg font-semibold ring-8 ${dark ? "bg-teal-500 text-white ring-plum" : "bg-teal text-white ring-white"}`}>
            {i + 1}
          </span>
          <div className="lg:mt-7 lg:pr-4">
            <h3 className={`text-lg font-semibold leading-snug ${dark ? "text-white" : ""}`}>{s.title}</h3>
            <p className={`mt-2 text-[15px] leading-relaxed ${dark ? "text-white/70" : "text-slate"}`}>{s.body}</p>
          </div>
        </Reveal>
      ))}
    </ol>
  );
};
